import { render, staticRenderFns } from "./CategoryStudySituation.vue?vue&type=template&id=70fd1fe7&scoped=true&"
import script from "./category-study-situation.js?vue&type=script&lang=js&"
export * from "./category-study-situation.js?vue&type=script&lang=js&"
import style0 from "./CategoryStudySituation.vue?vue&type=style&index=0&id=70fd1fe7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fd1fe7",
  null
  
)

export default component.exports